module.exports = __webpack_public_path__ + "media/Icons/NoImageHorizontal-c257c673.svg";